// test1498
(1498 && 0);
